import { actions } from '../../../utils/constants';

const INITIAL_STATE = {
  globalStatus: {},
  localStatus: {},
  coachesInfoArray: [],
  syncronizing: false,
  searchInput: '',
  token: ''
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case actions.SET_GLOBAL_STATUS:
      return { ...state, globalStatus: { ...payload } };

    case actions.SET_LOCAL_INFO:
      return { ...state, localStatus: { ...payload } };

    case actions.SET_COACHES_ARRAY:
      return { ...state, coachesInfoArray: payload };

    case actions.SET_SYNC:
      return { ...state, syncronizing: payload }

    case actions.SET_SEARCH_VALUE:
      return { ...state, searchInput: payload }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/containers/statistics/statistics.reducer.js